(function () {
  function computeOverlay() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    let overlay = 0;

    const sticky = document.getElementById('chagualBarSticky');
    if (sticky && sticky.classList.contains('is-active')) {
      const r = sticky.getBoundingClientRect();
      const touchesBottom = r.bottom >= vh - 1 && r.top < vh;
      if (touchesBottom) overlay = Math.ceil(r.height);
    }

    document.documentElement.style.setProperty('--chagual-wa-bottom-overlay', overlay + 'px');
  }

  let raf = 0;
  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      computeOverlay();
    });
  }

  window.addEventListener('load', computeOverlay, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });

  const sticky = document.getElementById('chagualBarSticky');
  if (sticky) {
    const mo = new MutationObserver(schedule);
    mo.observe(sticky, { attributes: true, attributeFilter: ['class', 'style'] });
  }
})();